var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getSocket } from '../../utils/getSocket';
import { reconnectToWebSocket } from '../session/socket';
export const scribeRogerVoiceMessage = (messageId) => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    const { conversationEnded } = getState().scribeConversation;
    if (conversationEnded)
        return;
    yield reconnectToWebSocket()(dispatch, getState);
    const insertPayload = {
        type: 'play-message',
        data: {
            messageId,
        },
    };
    const socket = getSocket();
    socket.send(JSON.stringify(insertPayload));
});
